<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-title> {{ 'STUDY.TITLE' | translate }} </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid id="study_page">
    <ion-row>
      <ion-col size="1200">
        <div class="study-header">
          <h2>{{ 'STUDY.WORDS_STUDYING' | translate }} {{ targetLanguage }}</h2>
          <div class="study-stats">
            <span class="stat stat-new">{{ 'STUDY.HARD' | translate }}: {{ newCount }}</span>
            <span class="stat stat-young">{{ 'STUDY.DIFFICULT' | translate }}: {{ youngCount }}</span>
            <span class="stat stat-mature">{{ 'STUDY.EASY' | translate }}: {{ matureCount }}</span>
          </div>
          <div class="study-total"> {{ getWordsStudying() }} </div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="flashCards && flashCards.length > 0">
      <ion-col size="1200">
        <div class="study-controls">
          <ion-button fill="clear" (click)="toggleSortOrder()">
            <ion-icon *ngIf="sortDescending" name="arrow-down-outline"></ion-icon>
            <ion-icon *ngIf="!sortDescending" name="arrow-up-sharp"></ion-icon>
              <span *ngIf="sortDescending">{{ 'STUDY.NEWEST_TO_OLDEST' | translate }}</span>
              <span *ngIf="!sortDescending">{{ 'STUDY.OLDEST_TO_NEWEST' | translate }}</span>
          </ion-button>
          <ion-button id="start-study-session" (click)="beginLesson()" color="success" size="small" class="begin-btn"> {{ 'STUDY.BEGIN_STUDYING' | translate }} </ion-button>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="flashCards && flashCards.length > 0">
      <ion-col size="1200">
        <ion-list lines="none" class="flashcard-list">
          <ion-item
            *ngFor="let card of flashCards"
            [ngClass]="{
              'flashcard-new': getCardStatus(card) === 'HARD',
              'flashcard-young': getCardStatus(card) === 'DIFFICULT',
              'flashcard-mature': getCardStatus(card) === 'EASY'
            }"
            class="flashcard-card"
            (click)="openFlashCard(card)"
          >
          <ion-text>
            <h3>{{ card.root_word }}</h3>
            <!--<p class="flashcard-translation">{{ card.translation }}</p>-->
            <p class="flashcard-status">{{ translateStatus(getCardStatus(card)) }} </p>
          </ion-text>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>